<template>
   <div  >
      <!--弹框登录-->
    <el-dialog  :visible.sync="dialogVisible"  :before-close="handleClose">
      <div class="dialog_midde">
        <div class="dialog_conent">
          <div class="moblie_logo" @click.prevent="onTout()">
            <img class="" src="@/assets/images/logo.jpg" alt="" />
          </div>
          <div class="moblie_bater">
            <div class="login_box mt-10">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="账号登录" name="first">
                  <el-form
                    class="info_form"
                    :rules="loginRules"
                    :model="loginForm"
                    ref="loginForm"
                    label-width="80px"
                  >
                    <el-form-item
                      class="phone"
                      prop="mobile"
                      style="width: 100%"
                    >
                      <img
                        class="icon"
                        src="@/assets/images/mobile.png"
                        alt=""
                      />
                      <el-input
                        class="myClass"
                        placeholder="请输入手机号码"
                        v-model="loginForm.mobile"
                        maxlength="11"
                      ></el-input>
                    </el-form-item>
                    <el-form-item class="phone" prop="password">
                      <img
                        class="icons"
                        src="@/assets/images/password.png"
                        alt=""
                      />
                      <el-input
                        class="myClass"
                        type="password"
                        placeholder="请输入密码"
                        v-model="loginForm.password"
                      ></el-input>
                    </el-form-item>
                    <el-form-item style="width: 100%">
                      <el-button
                        class="reset_login"
                        @click="goLogin('loginForm')"
                        >确定登录</el-button
                      >
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
                <!--短信登录-->
                <el-tab-pane label="短信登录" name="second">
                  <el-form
                    class="info_forms"
                    :rules="rules"
                    :model="form"
                    label-width="80px"
                    ref="form"
                  >
                    <el-form-item prop="mobile" style="width: 100%">
                      <img
                        class="icon"
                        src="@/assets/images/mobile.png"
                        alt=""
                      />
                      <el-input
                        class="myClass"
                        placeholder="请输入手机号码"
                        v-model="form.mobile"
                        maxlength="11"
                      ></el-input>

                      <!-- <el-button>发送验证码</el-button> -->
                    </el-form-item>
                    <el-form-item
                      class="code"
                      prop="imgCode"
                      style="width: 100%"
                    >
                      <img
                        class="icon"
                        src="@/assets/images/security.png"
                        alt=""
                      />
                      <el-input
                        class="myClass"
                        placeholder="图形验证码"
                        v-model="form.imgCode"
                      ></el-input>
                      <img
                        class="graphic_code"
                        :src="imgUrl"
                        alt=""
                        @click.prevent="getCaptcha()"
                      />
                    </el-form-item>
                    <el-form-item
                      class="shortCode"
                      prop="smsCode"
                      style="width: 100%"
                    >
                      <el-input
                        class="myClass"
                        placeholder="短信验证码"
                        v-model="form.smsCode"
                      ></el-input>
                      <button class="shortBtn" @click.prevent="onCode()">
                        {{ getCodeText }}
                      </button>
                    </el-form-item>
                    <el-form-item style="width: 100%">
                      <el-button
                        class="reset_login"
                        @click="shortSubmit('form')"
                        >确定登录</el-button
                      >
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </div>

            <div class="retrieve fdc">
              <p class="underline" @click.prevent="onRetrieve()">找回密码</p>
              <p>
                <span>没有账号,</span>
                <span class="underline" @click.prevent="onRegister()"
                  >去注册</span
                >
              </p>
            </div>
            <div class="mt-20">
              <div class="other_fail">你可以用以下方式登录</div>
              <div class="other_icon">
                <a
                  href="https://open.weixin.qq.com/connect/qrconnect?appid=wx72a1afef42a9b317&redirect_uri=http%3A%2F%2Fwww.zhiwubang.cn%2Fapi%2Fzwb%2Fapp%2Fwechat%2Fcallback&response_type=code&scope=snsapi_login&state=20201130#wechat_redire"
                >
                  <img class="WeChat" src="@/assets/images/WeChat.png" alt="" />
                </a>
                <a
                  href="https://api.weibo.com/oauth2/authorize?client_id=3813487040&response_type=code&redirect_uri=http%3a%2f%2fwww.zhiwubang.cn%2fapi%2fzwb%2fapp%2fweibo%2fcallback"
                >
                  <img
                    class="micro"
                    src="@/assets/images/micro-blog.png"
                    alt=""
                  />
                </a>
                <a
                  href="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101920072&redirect_uri=http%3a%2f%2fwww.zhiwubang.cn%2fapi%2fzwb%2fapp%2fqq%2fcallback&state=20201130"
                >
                  <img class="qq" src="@/assets/images/QQ.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
   </div>
</template>
<script>
import { getUUID } from "@/utils/index";
import { smslogin, SmsCaptcha } from "@/api/user";
import {getUsers} from "@/api/coment";
export default {
   props:{
       dialogVisible:{
         type:Boolean
       }
   },
   data(){
    //验证手机号规则
    var checkMobile = (rule, value, cb) => {
    // 验证手机号的正则表达式
    const regMobile = /^1\d{10}$/;
    if (regMobile.test(value)) {
        return cb();
    }
    cb(new Error("请输入合法的手机号"));
    };
      return{
        form: {
            //短信
            mobile: "",
            imgCode: "", //图形验证码
            smsCode: "",
        },
        loginForm: {
            //密码
            mobile: "",
            password: "", //短信验证码
        },
        rules: {
            mobile: [{ required: true, validator: checkMobile, trigger: "blur" }],
            password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        },
        loginRules: {
            mobile: [{ required: true, validator: checkMobile, trigger: "blur" }],
            password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        },
        activeName: "first",
        type: "login",
        redirect: undefined,
        imgUrl: "",
        uid: "",
        userObj: {},
        getCodeText: "获取验证码",
        getCodeisWaiting: false,
      }
   },
   created(){
       this.getCaptcha();
   },
   methods:{
     handleClose() {
        // 关闭前回调
         this.$emit('update:dialogVisible',false); //有效
    },
    handleClick(tab, event) {},
    //获取图形验证码
    getCaptcha() {
      this.uid = getUUID();
      this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
    },
    //倒计时
    setTimer() {
      let holdTime = 60;
      this.getCodeText = "重新获取(60)";
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.getCodeisWaiting = false;
          this.getCodeText = "获取验证码";
          holdTime = 60;
          clearInterval(this.Timer);
          return;
        }
        this.getCodeText = "重新获取(" + holdTime + ")";
        holdTime--;
      }, 1000);
    },
    //发送验证码
    onCode() {
      if (!this.form.mobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (!this.form.imgCode) {
        this.$message({
          message: "请输入图形验证码",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (this.getCodeisWaiting) {
        return false;
      }
      let params = {
        mobile: this.form.mobile,
        uuid: this.uid,
        imgCode: this.form.imgCode,
      };
      this.setTimer();
      this.getCodeisWaiting = true;
      SmsCaptcha(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //用户登录-账号密码
    goLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("user/login", {
              mobile: this.loginForm.mobile,
              password: this.loginForm.password,
            })
            .then((res) => {
              if(res.code == 0){
                this.getUser();
                this.$message({
                  message: "登录成功",
                  type: "success",
                  duration: 1000,
                });
               this.$emit('update:dialogVisible',false);
                // this.reload();
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //短信登录
    shortSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("user/smslogin", {
              mobile: this.form.mobile,
              smsvaildCode: this.form.smsCode,
              uuid: this.uid,
              vaildCode: this.form.imgCode,
            })
            .then((res) => {
              if(res.code == 0){
                this.dialogVisible = false;
                this.$message({
                  message: "登录成功",
                  type: "success",
                  duration: 1000,
               });
               this.$emit('update:dialogVisible',false);
              }
            })
            .catch(() => {});
        }
      });
    },
    onRetrieve() {
      this.$router.push("/retrieve");
    },
    onRegister() {
      this.$router.push("/register");
    }, 
      //获取用户信息
    getUser() {
      let parmas = {};
      getUsers(parmas)
        .then((res) => {
          if (res.code == 0) {
            this.userObj = res.data;
            if (
              null == res.data.mobile ||
              "null" == res.data.mobile ||
              "" == res.data.mobile
            ) {
              this.$router.push("/mobile_phone");
            } else {
              this.$router.go(0);
            }
          }
        })
        .catch((err) => {});
    }, 
   } 
}
</script>
<style  scoped="scoped" lang='less'>
/**弹框 */
/deep/.el-dialog {
  width: 400px;
  background: #ffffff !important;
}
.dialog_midde {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.dialog_conent {
  width: 368px;
  // background:rgba(255, 255, 255, 0.8);
}
.moblie_bater {
  margin: 15px 30px;
}
/deep/ .el-tabs__nav-wrap::after {
  width: 0%;
}
/deep/ .el-tabs__item {
  font-size: 18px;
}
/deep/ .el-tabs__item.is-active {
  color: #333333;
  font-weight: bold;
}
/deep/ .el-tabs__item:hover {
  color: #333333;
}
/deep/ .el-tabs__active-bar {
  background-color: #333333;
}
.phone {
  position: relative;
}
.code {
  position: relative;
}
/deep/.phone .el-button {
  position: absolute;
  height: 49px;
  top: 0;
  right: 0;
  color: #ffffff;
  width: 95px;
  background: #fb7103;
  border: none;
  font-size: 12px;
}
/deep/.phone .el-button:hover {
  color: #ffffff;
}
.icon {
  width: 24px;
  height: 26px;
  position: absolute;
  top: 12px;
  left: 10px;
  z-index: 100;
}
.icons {
  width: 32px;
  height: 34px;
  position: absolute;
  top: 7px;
  left: 5px;
  z-index: 100;
}
/deep/.el-input__inner {
  height: 50px;
}
/deep/.el-form-item__content {
  margin-left: 0px !important;
}
/deep/input.el-input__inner {
  padding-left: 40px;
  font-size: 12px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
}
/deep/.el-button {
  border: none;
}
/deep/.el-select .el-input__inner {
  color: #333333;
}
/deep/.el-input--suffix .el-input__inner {
  padding-left: 40px;
  font-size: 12px;
  color: #999999;
}
/deep/.el-select .el-input__inner:focus {
  border-color: #eeeeee;
}
/deep/.el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #eeeeee;
}
/deep/.el-form-item__content {
  margin-left: 0px !important;
}
/deep/.el-input__inner {
  height: 50px;
  padding-left: 40px;
  font-size: 12px;
  color: #999999;
}
.reset_login {
  width: 100%;
  height: 50px;
  background: linear-gradient(104deg, #a2dc14, #69cc1e) !important;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.reset_login:hover {
  color: #ffffff !important;
}
.retrieve p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.code {
  position: relative;
}
.graphic_code {
  position: absolute;
  right: 0;
  top: 0;
  width: 125px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  background: #cdcdcd;
  color: #323232;
}
.shortCode {
  position: relative;
}
.shortBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 125px;
  height: 50px;
  background: #e5e5e5;
}
.retrieve p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.underline {
  padding-bottom: 5px;
  text-decoration: underline;
  cursor: pointer;
}
.other_fail {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.other_icon {
  display: flex;
  justify-content: space-around;
  margin-top: 25px;
}
.other_icon img {
  width: 25px;
  height: 25px;
}
.moblie_logo {
  display: flex;
  justify-content: center;
  margin-top: -12px;
}
.moblie_logo img {
  width: 152px;
  height: 44px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/loginDialog.vue